import type { Special } from "./types";

export const specials: Special[] = [
  {
    id: "family-web",
    title: "血缘之外：家庭伦理剧的主场",
    kicker: "策划 / 家庭",
    lead: "家庭是最小的伦理战场，餐桌上有多少沉默，就有多少故事。",
    intro:
      "本期专题收录五部以家庭结构为核心的日本伦理剧。它们看似都在讲家事，却分别从养育、继承、失踪与共同抚育四个方向切入，把「家人」这个被反复使用的词重新拆开，看看里面究竟装着什么。我们不以评分排序，而是按叙事视角排列，建议从最贴近日常的那一部开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20traditional%20Japanese%20dining%20room%20at%20dusk%20with%20a%20low%20wooden%20table%20set%20for%20four%20empty%20place%20settings%2C%20paper%20lantern%20glow%2C%20muted%20amber%20and%20deep%20charcoal%20tones%2C%20quiet%20melancholic%20atmosphere%2C%20editorial%20film%20still&width=1600&height=900&seq=special-family-web-01&orientation=landscape",
    editorPickIds: ["the-inheritance-room", "silent-tide", "two-mothers", "the-returned-daughter", "showa-kitchen"],
    reviews: [
      {
        title: "为什么从「继承」看家庭？",
        text: "遗嘱是家庭关系的X光片。当一个人离开，他留下的分配方案会精确地暴露此前的偏爱与亏欠。《继承人的房间》把镜头固定在那间会议室里，让观众自己算这笔账。",
      },
      {
        title: "养育是不是一种权力？",
        text: "《静默的潮汐》与《两个母亲的春天》形成有趣的对照：前者是养育十七年后被追讨，后者是从一开始就选择共同持有。两者都在问同一件事——照顾一个人，究竟是付出还是占有。",
      },
    ],
    relatedIds: ["quiet-voices", "showa-index"],
  },
  {
    id: "quiet-voices",
    title: "沉默的重量：职场与良知命题",
    kicker: "策划 / 社会",
    lead: "最响亮的声音，往往是那句没有说出口的话。",
    intro:
      "如果把伦理剧中的冲突换一种衡量单位，那一定是「沉默的时长」。本期专题聚焦组织内部的道德抉择：医院、企业、法庭、港口，主角都在不同程度上选择了不说。五部作品放在一起看，会发现沉默从来不是空白，而是一种需要成本的选择。",
    cover:
      "https://readdy.ai/api/search-image?query=Dim%20corporate%20corridor%20at%20night%20with%20long%20shadows%20and%20a%20single%20lit%20doorway%2C%20cold%20slate%20grey%20palette%20with%20amber%20light%20spill%2C%20minimal%20architectural%20cinematography%2C%20tense%20quiet%20mood&width=1600&height=900&seq=special-quiet-voices-02&orientation=landscape",
    editorPickIds: ["white-noise-ward", "silent-witness-24", "salaryman-ethic", "silent-tide", "borrowed-name"],
    reviews: [
      {
        title: "组织伦理的三种典型处境",
        text: "一是被迫签署（《白噪音病栋》），二是被迫作证（《证人的二十四小时》），三是被迫沉默（《科长的沉默》）。三种处境共享同一套逻辑：个人被要求为集体的体面让路。",
      },
      {
        title: "为什么这些剧都不给痛快结局？",
        text: "因为它们关心的不是惩罚，而是后果如何被日常消化。主角大多没有辞职，也没有成为英雄，他们只是学会了在某个清晨继续上班。这种处理更接近真实。",
      },
    ],
    relatedIds: ["family-web", "showa-index"],
  },
  {
    id: "showa-index",
    title: "昭和索引：时间如何改变对错",
    kicker: "策划 / 年代",
    lead: "同一件事，在不同的年代里会有完全不同的正确答案。",
    intro:
      "年代背景不是装饰。当剧情被放在昭和、平成与令和三个时间坐标上，伦理判断本身也会随之晃动。本期专题以年代为轴，选入从战后家庭到泡沫前夜的作品，附上我们整理的时代关键词，方便你在观看前建立语境。",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Japanese%20street%20in%20the%201970s%20with%20old%20wooden%20shopfronts%2C%20incandescent%20signs%20and%20a%20passing%20bicycle%2C%20warm%20golden%20evening%20light%2C%20muted%20sepia%20and%20deep%20olive%20tones%2C%20cinematic%20film%20grain&width=1600&height=900&seq=special-showa-index-03&orientation=landscape",
    editorPickIds: ["showa-kitchen", "the-returned-daughter", "borrowed-name", "borrowed-light"],
    reviews: [
      {
        title: "年代剧的伦理差异在哪里？",
        text: "昭和背景下的角色很少公开质疑结构，他们的挣扎发生在结构内部；而当代作品则更愿意直接说出「这个制度不对」。两种处理没有优劣，只是负担不同。",
      },
      {
        title: "观看建议",
        text: "先看《昭和厨房》建立日常感，再看《回来的女儿》理解那个时代家庭内部的沉默，最后用《借名之夜》把视角移到城市边缘。",
      },
    ],
    relatedIds: ["family-web", "spring-lineup"],
  },
  {
    id: "forbidden-house",
    title: "越界之前：爱情与克制",
    kicker: "策划 / 情感",
    lead: "我们讨论的不是心动，而是心动之后的那段路。",
    intro:
      "这一组作品共同的特点是：镜头推进得极慢，人物的所有动作都经过考虑。它们不评价，也不美化，只是把「越界」这个词拆成无数个具体瞬间，让你在每一个瞬间都能看见另一条可能的路。",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20figures%20silhouetted%20at%20opposite%20ends%20of%20a%20rainy%20narrow%20Tokyo%20street%20at%20night%2C%20warm%20lantern%20reflections%20on%20wet%20pavement%2C%20deep%20navy%20blue%20tones%20with%20orange%20highlights%2C%20cinematic%20anamorphic%20still&width=1600&height=900&seq=special-forbidden-house-04&orientation=landscape",
    editorPickIds: ["borrowed-light", "blue-hour-shop", "silent-tide"],
    reviews: [
      {
        title: "克制为什么更难拍？",
        text: "因为所有张力都要靠停顿、距离和调度完成。《借来的光》第三集两人在便利店门口分开，长达十秒没有对白，却让观众记住了那一整集。",
      },
    ],
    relatedIds: ["spring-lineup", "quiet-voices"],
  },
  {
    id: "spring-lineup",
    title: "春季更新：本季值得一看的六部",
    kicker: "策划 / 更新",
    lead: "编辑部按观看顺序整理的本季片单，附一句实话。",
    intro:
      "每季度我们都会按「如果只有一晚，看哪部」的标准重新排序。这一期收录了近期上线的作品，从新人律师的职场困境到杂货店里的旧物记忆，篇幅都不长，适合在通勤路上分集看完。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20spring%20Japanese%20neighborhood%20scene%20with%20cherry%20blossoms%20over%20a%20quiet%20laneway%20and%20warm%20evening%20window%20lights%2C%20muted%20pale%20pink%20and%20slate%20grey%20tones%2C%20refined%20editorial%20cinematography&width=1600&height=900&seq=special-spring-lineup-05&orientation=landscape",
    editorPickIds: ["the-quiet-lawyer", "blue-hour-shop", "two-mothers", "borrowed-light"],
    reviews: [
      {
        title: "本季排序理由",
        text: "《沉默的第一课》胜在结构清晰，适合入门；《蓝调时分的杂货店》胜在氛围，适合睡前；《两个母亲的春天》胜在难度最低但余味最长。",
      },
    ],
    relatedIds: ["forbidden-house", "showa-index"],
  },
];

export const findSpecial = (id?: string) => specials.find((item) => item.id === id);